import { Link, useParams } from 'react-router-dom';
import { Breadcrumb, Layout, theme } from 'antd';

import { FeatureFlags, PageLayout } from '@app/web-components';

import { NotFoundPage } from '../../../common';
import { useGetAccessDependency } from '../data';
import { AddForm } from '../forms';

const DEPENDENCIES_PAGE_TITLE = 'Manage Dependencies';

export const DependenciesPage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { id } = useParams();

  const accessId = Number(id) || 0;
  const findAccessDependencyQuery = useGetAccessDependency(accessId);
  const { isFeatureEnabled } = FeatureFlags.useFeatureFlags();

  if (!isFeatureEnabled('global_dependencies')) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: <Link to="../">Access</Link> },
          { title: DEPENDENCIES_PAGE_TITLE },
        ]}
      />
      <Layout.Content
        style={{
          padding: 24,
          margin: 'auto',
          height: '100%',
          width: '100%',
          maxWidth: 1200,
          minHeight: 0,
          background: colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title={DEPENDENCIES_PAGE_TITLE} />
        {findAccessDependencyQuery.error ? (
          <div>failed</div>
        ) : findAccessDependencyQuery.isPending ? (
          <div>Loading...</div>
        ) : !findAccessDependencyQuery.data ? (
          <div>Loading...</div>
        ) : (
          <AddForm id={Number(id)} record={findAccessDependencyQuery.data?.data} />
        )}
      </Layout.Content>
    </>
  );
};
